import { render, staticRenderFns } from "./BillingDownloads.vue?vue&type=template&id=a87a0d6a&"
import script from "./BillingDownloads.vue?vue&type=script&lang=js&"
export * from "./BillingDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports